import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetProtectedValueNotesService } from './get-protected-value-notes/get-protected-value-notes.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    GetProtectedValueNotesService
  ],
})
export class ProtectedValuesModule {}
